<!-- 咨讯按钮组件 -->
<template>
    <div class="consultation" @click="ShowClick">
        <img class="consultation-icon" src="@/assets/icon/icon_message.png" alt="">
        <div class="consultation-title">
            <h1>在线咨询</h1>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        ShowClick() {
            this.$emit("closePopu", true)
        }
    }
}
</script>

<style lang="scss" scoped>
.consultation {
    position: fixed;
    right: 0;
    top: calc((100vh - 120px)/2);
    width: 38px;
    height: 120px;
    background: rgba(208, 2, 27, 1);
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    padding: 5px 0;
    box-sizing: border-box;
    align-items: center;
    z-index: 9;

    .consultation-icon {
        width: 22px;
        height: 22px;
    }

    .consultation-title {
        width: 100%;
        padding: 3px 8px;
        padding-bottom: 0;
        box-sizing: border-box;

        h1 {
            font-size: 15px;
            font-weight: 500;
            color: #fff;
            text-align: center;
        }
    }
}
</style>